import React from "react";
import { Languages, Layers } from "lucide-react";
import { OTHER_PLATFORMS, TURKISH_EVISA_PLATFORMS } from "@/lib/site";
import { Reveal, SectionHeading } from "@/components/landing/Reveal";
import { PlatformCard } from "@/components/landing/PlatformCard";

const GroupLabel = ({ icon: Icon, title, note }) => (
  <div className="flex flex-col gap-1 border-b border-slate-200 pb-4 sm:flex-row sm:items-center sm:justify-between">
    <h3 className="flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-[#0b1d3a]">
      <Icon className="h-4 w-4 text-[#0f6e73]" aria-hidden="true" />
      {title}
    </h3>
    <p className="text-xs text-slate-500">{note}</p>
  </div>
);

const PlatformGrid = ({ items, columns = "md:grid-cols-2 lg:grid-cols-3" }) => (
  <div className={`mt-6 grid grid-cols-1 gap-5 ${columns} lg:gap-6`}>
    {items.map((platform, index) => (
      <Reveal key={platform.key} delay={index * 0.06} className="h-full">
        <PlatformCard platform={platform} />
      </Reveal>
    ))}
  </div>
);

export const Platforms = () => (
  <section
    id="platforms"
    data-testid="platforms-section"
    className="scroll-mt-32 lg:scroll-mt-40 lg:flex lg:min-h-screen lg:items-start pb-10 pt-6 sm:pb-14 sm:pt-8 lg:py-12"
  >
    <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
      <SectionHeading
        eyebrow="Group platforms"
        title="The platforms the group operates"
        description="Dubai Vize Hattı is live today; the other portals are being prepared and each card becomes a live link the moment that website goes online."
      />

      <div className="mt-10" data-testid="platforms-turkish-group">
        <GroupLabel
          icon={Languages}
          title="Turkish-language Dubai visa portals"
          note="1 live · 4 launching soon"
        />
        <PlatformGrid items={TURKISH_EVISA_PLATFORMS} />
      </div>

      <div className="mt-14" data-testid="platforms-other-group">
        <GroupLabel
          icon={Layers}
          title="Other group platforms"
          note="English market, eSIM and insurance"
        />
        <PlatformGrid items={OTHER_PLATFORMS} />
      </div>
    </div>
  </section>
);
